var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-normal scroll d-flex flex-column",attrs:{"id":"mainpa"}},[_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{staticClass:"container py-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }